// -*- mode: js; js-indent-level: 2; -*-
import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

const store = new Vuex.Store({

  state: {
    beers: [],
    dealers: [],
    current_beer_details: {},
  },
  actions: {
    LOAD_BEER_DETAILS: function ({ commit }, { slug }) {
      return new Promise((resolve, reject) => {
        axios.get('/beers/' + slug).then((response) => {
          commit('SET_BEER_DETAILS', { details: response.data })
          resolve()
        }, () => {
          // console.log(err)
          reject()
        })
      })
    },

    LOAD_BEER_LIST: function ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/beers/').then((response) => {
          commit('SET_BEER_LIST', { list: response.data })
          resolve()
        }, () => {
          reject()
        })
      })
    },

    LOAD_DEALER_LIST: function ({ commit }) {
      axios.get('/dealers/').then((response) => {
        var dealers = [];
        for (var d of response.data) {
          if (d.address) {
            d.position = {lng: d.position_lng, lat: d.position_lat};
            dealers.push(d)
          }

        }
        commit('SET_DEALER_LIST', { list: dealers })
      }, () => {
        // console.log(err)
      })
    },
  },
  mutations: {
    SET_BEER_LIST: (state, { list }) => {
      state.beers = list
    },

    SET_DEALER_LIST: (state, { list }) => {
      state.dealers = list
    },

    SET_BEER_DETAILS: (state, { details }) => {
      state.current_beer_details = details
    }
  },
  getters: {
  }
})

export default store
